"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const selectors_1 = require("data/transactions/selectors");
const core_1 = require("companion-app-components/utils/core");
const CalTopHeader_1 = __importDefault(require("./CalTopHeader"));
const CalWeekDaysHeader_1 = __importDefault(require("./CalWeekDaysHeader"));
const CalDaysGrid_1 = __importDefault(require("./CalDaysGrid"));
const CalPrefsModal_1 = __importDefault(require("./CalPrefsModal"));
const CalAccountsPrefsModal_1 = __importDefault(require("./CalAccountsPrefsModal"));
const utils_1 = require("../utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.monthlyCalendarStyles);
function getCurrentMonthData(year, month) {
    const curMonthStr = (year && month) ? `${year}-${month}` : luxon_1.DateTime.local().toFormat(utils_1.dateFormat.full);
    const curMonthToSet = luxon_1.DateTime.fromFormat(curMonthStr, utils_1.dateFormat.full);
    const prevDaysOffset = utils_1.weekDays.findIndex((x) => x === curMonthToSet.weekdayLong);
    const startIntervalDate = curMonthToSet.minus({ days: prevDaysOffset });
    const availableRows = prevDaysOffset + curMonthToSet.daysInMonth > 35 ? 6 : 5; // 42 = 6*7 spaces | 35 = 5*7 spaces
    const endIntervalDate = startIntervalDate.plus({ days: availableRows * 7 });
    return ({
        date: curMonthToSet,
        dateStr: curMonthStr,
        name: curMonthToSet.toFormat(utils_1.dateFormat.friendly),
        days: curMonthToSet.daysInMonth,
        startIntervalDate,
        endIntervalDate,
    });
}
function reduceMonthTransactions(transactionsData, currentMonthData) {
    const monthInterval = luxon_1.Interval.fromDateTimes(currentMonthData.startIntervalDate, currentMonthData.endIntervalDate).splitBy({ days: 1 });
    const datesIntervalMap = (0, immutable_1.OrderedMap)(monthInterval.map((d) => [d.start.toISODate(), (0, immutable_1.List)()]));
    return transactionsData.reduce((map, x) => {
        const txnDate = luxon_1.DateTime.fromISO(x.postedOn).toISODate();
        return map.has(txnDate) ? map.set(txnDate, map.get(txnDate).push(x)) : map;
    }, datesIntervalMap);
}
const MonthlyCalendar = (props) => {
    const { classes } = useStyles();
    const { navFn, setDate, year, month, accountIds, showCloseButton, onClose } = props;
    const cachedYear = (0, react_1.useMemo)(() => year, [year]);
    const cachedMonth = (0, react_1.useMemo)(() => month, [month]);
    const cachedAccountIds = (0, react_1.useMemo)(() => accountIds, [accountIds]);
    const transactionsData = (0, react_redux_1.useSelector)((state) => {
        if (!cachedAccountIds || !(cachedAccountIds === null || cachedAccountIds === void 0 ? void 0 : cachedAccountIds.size))
            return (0, immutable_1.OrderedMap)();
        return (0, selectors_1.getTransactionsByFilter)(state, { accountIdsArray: cachedAccountIds });
    });
    const cachedTransactionsData = (0, react_1.useMemo)(() => transactionsData, [transactionsData]);
    const [curMonth, setCurMonth] = (0, react_1.useState)();
    const [daysTxsMap, setDaysTxsMap] = (0, react_1.useState)(null);
    const [showCalPrefs, setShowCalPrefs] = (0, react_1.useState)(false);
    const [showAccountPrefs, setShowAccountPrefs] = (0, react_1.useState)(null);
    const updateDateState = (0, react_1.useCallback)((newMonth, where) => {
        setDate(newMonth.toFormat(utils_1.yearFormat), newMonth.toFormat(utils_1.monthFormat));
        core_1.tracker.track(core_1.tracker.events.calendarOnDateChanged, { date: newMonth.toISODate(), where });
    }, [setDate]);
    const onTransactionClick = (0, react_1.useCallback)((txn) => {
        if (navFn)
            navFn(txn);
        core_1.tracker.track(core_1.tracker.events.calendarOnTransactionClick, { txnId: txn.id, where: 'Transaction Modal Calendar View' });
    }, [navFn]);
    const onPrefsOpen = (0, react_1.useCallback)(() => {
        setShowCalPrefs(true);
        core_1.tracker.track(core_1.tracker.events.calendarPrefModalOpen);
    }, [setShowCalPrefs]);
    const onPrefsClose = (0, react_1.useCallback)(() => {
        setShowCalPrefs(false);
    }, [setShowCalPrefs]);
    const onAccountsPrefsModalOpen = (0, react_1.useCallback)(() => {
        setShowAccountPrefs(true);
        core_1.tracker.track(core_1.tracker.events.calendarAccountsPrefsModalOpen);
    }, [setShowAccountPrefs]);
    const onAccountsPrefsModalClose = (0, react_1.useCallback)(() => {
        setShowAccountPrefs(false);
    }, [setShowAccountPrefs]);
    // mounted or updated
    (0, react_1.useEffect)(() => {
        const currentMonthData = getCurrentMonthData(cachedYear, cachedMonth);
        setCurMonth(currentMonthData);
        setDaysTxsMap(reduceMonthTransactions(cachedTransactionsData, currentMonthData));
    }, [cachedYear, cachedMonth, cachedTransactionsData]);
    (0, react_use_1.useEffectOnce)(() => {
        if (accountIds.size === 0 && showAccountPrefs === null) {
            onAccountsPrefsModalOpen();
        }
    });
    const cachedCurMonth = (0, react_1.useMemo)(() => curMonth, [curMonth]);
    const cachedDaysTxsMap = (0, react_1.useMemo)(() => daysTxsMap, [daysTxsMap]);
    return (<div className={classes.root}>
      <CalTopHeader_1.default curMonth={curMonth} updateDateState={updateDateState} onPrefsOpen={onPrefsOpen} onAccountsPrefsModalOpen={onAccountsPrefsModalOpen} showCloseButton={showCloseButton} onClose={onClose}/>
      <div className={classes.legendsRoot}>
        <span className={classes.income}>Income</span>
        <span className={classes.expense}>Expense</span>
        <span className={classes.overdue}>Overdue</span>
        <span className={classes.normal}>Transactions</span>
      </div>
      <CalWeekDaysHeader_1.default days={utils_1.shortWeekDays}/>
      <CalDaysGrid_1.default curMonth={cachedCurMonth} daysTxsMap={cachedDaysTxsMap} onTransactionClick={onTransactionClick} accountIds={cachedAccountIds}/>
      {showCalPrefs && <CalPrefsModal_1.default onClose={onPrefsClose}/>}
      {showAccountPrefs && <CalAccountsPrefsModal_1.default onClose={onAccountsPrefsModalClose}/>}
    </div>);
};
exports.default = react_1.default.memo(MonthlyCalendar);
